import {type ArticlePromoNewsletterRecord} from '~/_generated/graphql'
import {type ArticleWysiwygPromoNewsletterFragment} from '~/cms/components/_blog/ArticleWYSIWYG/_components/DatoWYSIWYGPromoNewsletter/_generated/fragment.graphql'
import {SingleLineStructuredText} from '~/cms/components/SingleLineStructuredText'
import {type SingleLineStructuredTextFragment} from '~/cms/components/SingleLineStructuredText/_generated/fragment.graphql'
import {WYSIWYGSingleLineStructuredText} from '~/cms/components/WYSIWYG/_components/WYSIWYGSingleLineStructuredText'
import {
  type HgBlogNewsletterList,
  type HgEmailFormData,
} from '~/design-system/hg/components'
import {api} from '~/mercuryWebBackend/api'

// this is a curried function since we don't know which newsletters to subscribe to when there are more than one
export const createNewsletterSubmitHandler = (
  selectedNewsletters: HgBlogNewsletterList[]
) => {
  return async (formData: HgEmailFormData): Promise<void> => {
    const {email} = formData

    await Promise.all(
      selectedNewsletters.map(async list => {
        if (list === 'meridian') {
          return await api.magazineSubscribe.fetch({
            params: {email},
            pathPieces: {},
          })
        }
        return await api.newsletterSubscribe.fetch({
          params: {
            email,
            list,
            source: window.location.href,
          },
          pathPieces: {},
        })
      })
    )
  }
}

export function getFormattedNewsletters(
  newsletters: ArticleWysiwygPromoNewsletterFragment['newsletters']
) {
  return newsletters.map(el => ({
    ...el,
    list: el.list as HgBlogNewsletterList,
    description: <WYSIWYGSingleLineStructuredText data={el.description} />,
  }))
}

export function getBlogNewsletterProps({
  heading,
  body,
  successMessage,
  newsletters,
}: ArticlePromoNewsletterRecord) {
  return {
    heading: (
      <SingleLineStructuredText data={heading as SingleLineStructuredTextFragment} />
    ),
    body: body ? (
      <SingleLineStructuredText data={body as SingleLineStructuredTextFragment} />
    ) : null,
    successMessage: (
      <SingleLineStructuredText
        data={successMessage as SingleLineStructuredTextFragment}
      />
    ),
    newsletters: getFormattedNewsletters(
      newsletters as ArticleWysiwygPromoNewsletterFragment['newsletters']
    ),
    onSubmit: createNewsletterSubmitHandler,
  }
}
